//import 'vite/modulepreload-polyfill';
import "../styles/fonts.scss";
import "../styles/bootstrap.scss";
import '../styles/site.scss';

import { ContactForm } from "./components/ContactForm";
import * as constants from "./constants"; 

let contactForm: ContactForm | null = null;

document.addEventListener("DOMContentLoaded", () => {
    if(document.getElementById(constants.ContactFormElementId) === null) {
        return;
    }
    
    contactForm = new ContactForm();
    contactForm.init();
});